import axios from "axios";

export const API_URL = process.env.REACT_APP_API_URL || "http://localhost:8000";

const api = axios.create({ baseURL: API_URL });

// Exact strings returned by get_current_active_subscriber (app/core/security.py) - matched
// precisely, not on status 403 alone, because other endpoints (e.g. /users/profile/{id} on a
// mismatched id) also 403 for reasons that must NOT redirect the user to /profile.
const SUBSCRIPTION_GATE_DETAILS = ["Subscription inactive", "Subscription expired"];

api.interceptors.response.use(
  (response) => response,
  (error) => {
    const url: string = error.config?.url || "";
    const isAuthEndpoint = url.includes("/auth/login") || url.includes("/auth/register");
    if (error.response?.status === 401 && !isAuthEndpoint) {
      localStorage.removeItem("token");
      // Full page navigation (a stale token is only discovered once a request already landed on
      // the target page) - React Router state can't survive it, so the destination is carried as
      // a query param instead and picked up by Login.tsx.
      const from = encodeURIComponent(window.location.pathname + window.location.search);
      window.location.href = `/login?from=${from}`;
      return new Promise(() => {});
    }
    if (
      error.response?.status === 403 &&
      SUBSCRIPTION_GATE_DETAILS.includes(error.response?.data?.detail) &&
      window.location.pathname !== "/profile"
    ) {
      window.location.href = "/profile?reason=subscription_inactive";
      return new Promise(() => {});
    }
    return Promise.reject(error);
  }
);

export default api;
